import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M6.075 15.91a7.6 7.6 0 0 1-2.381-1.604 7.6 7.6 0 0 1-1.603-2.381A7.3 7.3 0 0 1 1.5 9q0-1.556.591-2.925a7.6 7.6 0 0 1 1.603-2.381A7.6 7.6 0 0 1 6.075 2.09 7.3 7.3 0 0 1 9 1.5a7.3 7.3 0 0 1 2.925.591 7.6 7.6 0 0 1 2.381 1.603 7.6 7.6 0 0 1 1.604 2.381q.592 1.37.59 2.925a7.4 7.4 0 0 1-.591 2.925 7.5 7.5 0 0 1-1.603 2.381 7.6 7.6 0 0 1-2.381 1.604A7.25 7.25 0 0 1 9 16.5a7.3 7.3 0 0 1-2.925-.59M9 15q1.012 0 1.95-.328a6 6 0 0 0 1.725-.947l-8.4-8.4a6 6 0 0 0-.947 1.725A5.8 5.8 0 0 0 3 9q0 2.513 1.744 4.256T9 15m4.725-2.325a6 6 0 0 0 .947-1.725A5.8 5.8 0 0 0 15 9q0-2.513-1.744-4.256T9 3q-1.013 0-1.95.328-.938.327-1.725.947z"
    }, null, -1)
  ]))]))
}
export default { render: render }